import cx from 'classnames';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export const StartAdornment = ({ className, children }: Props): JSX.Element => {
  return <span className={cx(className, 'block mr-4')}>{children}</span>;
};
